import { FETCH_START, FETCH_END } from './ActionTypes';
import { SR_CONTRACT_START, SR_CONTRACT_END } from '../ManufactureChargeback/ActionTypes';
import axios from '../../../axios.conf';
import { toast as globalToast } from '../../../components/ToastManager';
import secureLocalStorage from 'react-secure-storage';
import { handleExecutionLog } from '../../../components/ExecutionLogHandler';

const BASE_API = 'manufacturer-chargeback/contract';

const fetchStart = () => ({ type: FETCH_START });
const fetchEnd = () => ({ type: FETCH_END });

export const createManufacturerChargebackContracts = (data, id, type) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const response = await createChargebackContractsAPI(data, id, type);
      dispatch(fetchEnd());

      const logNumber = response?.data?.log_number;
      if (logNumber) {
        const { hasError } = await handleExecutionLog(dispatch, logNumber);
        return { success: !hasError, response };
      } else {
        globalToast.showSuccess(response?.data?.message || response?.data?.response);
        return { success: true, response };
      }
    } catch (error) {
      dispatch(fetchEnd());
      if (error.response?.data?.log_number) return { success: false, response: error.response };
      throw error;
    }
  };
};

const createChargebackContractsAPI = (data, id, type) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  if (type === 'edit') {
    return axios.put(BASE_API, { ...data }, { headers });
  } else if (type === 'delete') {
    return axios.delete(`${BASE_API}/${id}`, { headers });
  } else {
    return axios.post(BASE_API, data, { headers });
  }
};

// Process Code (Designer Studio > Manufacturer Chargeback)
const PROCESS_CODE_API = 'mc/process-codes';
// manufacturerChargebackData.loading is driven by SR_CONTRACT_START/END, not FETCH_START/END.
const processCodeFetchStart = () => ({ type: SR_CONTRACT_START });
const processCodeFetchEnd = () => ({ type: SR_CONTRACT_END });

// id: record id for 'edit' (PUT /{id}) and 'delete' (DELETE /{id}); unused for 'add'.
export const createManufacturerProcessCode = (data, id, type) => {
  return async (dispatch) => {
    dispatch(processCodeFetchStart());
    try {
      const response = await createManufacturerProcessCodeAPI(data, id, type);
      dispatch(processCodeFetchEnd());

      const logNumber = response?.data?.log_number;
      if (logNumber) {
        const { hasError } = await handleExecutionLog(dispatch, logNumber);
        return { success: !hasError, response };
      } else {
        globalToast.showSuccess(response?.data?.message || response?.data?.response);
        return { success: true, response };
      }
    } catch (error) {
      dispatch(processCodeFetchEnd());
      if (error.response?.data?.log_number) return { success: false, response: error.response };
      throw error;
    }
  };
};

const createManufacturerProcessCodeAPI = (data, id, type) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  const url = `${PROCESS_CODE_API}/${encodeURIComponent(id)}`;
  if (type === 'edit') {
    return axios.put(url, data, { headers });
  } else if (type === 'delete') {
    return axios.delete(url, { headers });
  } else {
    return axios.post(PROCESS_CODE_API, data, { headers });
  }
};

export const getManufacturerProcessCodeItem = (id) => {
  return async (dispatch) => {
    dispatch(processCodeFetchStart());
    try {
      const headers = {
        Authorization: secureLocalStorage.getItem('aTk'),
      };
      const response = await axios.get(`${PROCESS_CODE_API}/${encodeURIComponent(id)}`, { headers });
      return response?.data?.response || {};
    } finally {
      dispatch(processCodeFetchEnd());
    }
  };
};
